export { default } from './InfoBox'
